import { Component, computed, input, output } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { CardUIType, LMS_PLATFORM_LABELS, PlaylistCardShort } from '@app/app/shared/models';
import { LucideLock } from '@lucide/angular';

@Component({
  selector: 'ptl-card-item-main-view',
  templateUrl: './card-item-main-view.component.html',
  styleUrls: ['./card-item-main-view.component.scss'],
})
export class CardItemMainViewComponent {
  protected readonly LucideLock = LucideLock;

  card = input<PlaylistCardShort>();
  cardIndex = input<number>(0);
  cardType = input<CardUIType>('general');
  showImage = input(true);
  showMeta = input(true);
  showReviews = input(true);

  cardClick = output<PlaylistCardShort>();

  private readonly CARD_GRADIENTS = [
    'linear-gradient(135deg, #e8d5f5, #c5b3e8)',
    'linear-gradient(135deg, #d5e8f5, #b3c5e8)',
    'linear-gradient(135deg, #c5e8d5, #8dd5b0)',
    'linear-gradient(135deg, #d5f5e8, #8de8c5)',
    'linear-gradient(135deg, #d5d5f5, #b3b3e8)',
    'linear-gradient(135deg, #f5e8d5, #e8d5a0)',
  ];

  gradient = computed(() => this.CARD_GRADIENTS[this.cardIndex() % this.CARD_GRADIENTS.length]);

  cardSubheader = computed(() => {
    const card = this.card();
    return card?.subHeader ? LanguageCodeHelper.getDataByLanguageCode(card.subHeader).value.trim() : '';
  });

  lmsPlatformLabel = computed(() => {
    const platformType = this.card()?.lmsPlatformType;
    return platformType ? LMS_PLATFORM_LABELS[platformType] || platformType : '';
  });

  typeDisplayName = computed(() => {
    const type = this.card()?.v3CardType || this.card()?.collectionType;
    if (!type) return '';
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  });

  typeColorClass = computed(() => {
    const type = this.card()?.v3CardType || this.card()?.collectionType;
    if (!type) return '';
    const t = type.toUpperCase();
    if (t === 'COURSE' || t === 'STANDARD') return 'type-course';
    if (t === 'EVENT') return 'type-event';
    if (t === 'MODULE' || t === 'PROGRAM') return 'type-module';
    return 'type-default';
  });

  progressPct = computed(() => {
    const c = this.card();
    if (c?.completed) return 100;
    const completed = c?.completedItemsCount ?? 0;
    const total = c?.totalItemsCount ?? 0;
    return total > 0 ? Math.round((completed / total) * 100) : 0;
  });

  timeText = computed(() => {
    return null;
  });

  activitiesText = computed(() => {
    const total = this.card()?.totalItemsCount;
    if (!total) return null;
    return `${total} Activities`;
  });

  onCardClick(): void {
    const card = this.card();
    if (card?.lmsCourseUrl) {
      window.open(card.lmsCourseUrl, '_blank', 'noopener,noreferrer');
    }
    this.cardClick.emit(card);
  }
}
